import React, { Fragment, useCallback, useState, useEffect, useRef } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from "react-redux";


// Material UI
import {
    Grid
} from '@mui/material';
// Components
import Modal, { ModalBody, ModalFooter } from 'Components/Modal';
import { Button, Input, Form } from 'Components';
import { NotificationManager } from "Components/Notifications";
//Core
import { GetApiErrorLan } from 'Core/logManager'
// Actions
import {
    openDashboardPanel,
    createDashboardPanel,
    updateDashboardPanel,
    clearRedux
} from "Redux/actions";


const CreateEditDashboardPanel = (props) => {
    // Intl
    const { messages } = useIntl();
    const { callback } = props;
    // Hooks
    const dispatch = useDispatch();
    const formRef = useRef();

    // State local
    const {
        loadingCreate,
        openCreate,
        dashboardEdit,
        updateResponseDashboard,
        dashboardResponse,
    } = useSelector((state) => state.dashboardPanelRedux);

    const [dashboardName, setDashboardName] = useState('');
    const [isWasSent, setIsWasSent] = useState(false);


    const handleClose = useCallback(() => {
        dispatch(openDashboardPanel(false));
        dispatch(clearRedux("DASHBOARD_PANEL", {
            openCreate: false,
            loadingCreate: false,
            updateResponseDashboard: null
        }));
    });

    const handleError = response => {
        NotificationManager.error(
            messages[GetApiErrorLan(response)] || messages["errorMessage"],
            messages["error"],
            4000
        );
    };

    useEffect(() => {
        if (dashboardEdit) {
            setDashboardName(dashboardEdit.name)
        }
    }, [dashboardEdit]);


    useEffect(() => {
        if (updateResponseDashboard?.id) {
            callback(dashboardName)
            handleClose()
            NotificationManager.success(
                messages["dashboardPanel_edit_confirmation_message_rename_dashboard_description"],
                messages["dashboardPanel_edit_confirmation_message_rename_dashboard_title"],
                4000
            );
        } else if (updateResponseDashboard?.errorData?.errors?.length > 0 && isWasSent) {
            handleError(updateResponseDashboard)
        }
    }, [updateResponseDashboard]);

    useEffect(() => {
        if (dashboardResponse?.createDashboard?.id) {
            callback(dashboardName)
            handleClose()
            NotificationManager.success(
                messages["dashboardPanel_edit_confirmation_message_create_dashboard_description"],
                messages["dashboardPanel_edit_confirmation_message_create_dashboard_title"],
                4000
            );
        } else if (dashboardResponse?.errorData?.errors?.length > 0 && isWasSent) {
            handleError(dashboardResponse)
        }
    }, [dashboardResponse]);



    const title = (dashboardEdit) ? `${messages['dashboardPanel_title_edit']} ${dashboardEdit.name}` : messages['dashboardPanel_title_new'];

    return (
        <Fragment>
            <Modal
                title={title}
                open={openCreate}
                size={`small`}
                handleClose={() => handleClose()}
                position="right"
                loading={loadingCreate}
            >
                <ModalBody style={{ overflow: 'hidden', height: '100%', padding: 15 }}>
                    <Form
                        ref={formRef}
                        onValidSubmit={() => {
                            if (dashboardEdit) {
                                dispatch(updateDashboardPanel({ id: dashboardEdit.id, name: dashboardName }));
                            } else {
                                dispatch(createDashboardPanel({ name: dashboardName }));
                            }
                        }}
                    >
                        <Grid
                            container
                            justifyContent={'center'}
                            direction={'column'}
                            className="paddingBody"
                            spacing={2}
                        >
                            <Grid item sm={12}>
                                <Input
                                    id="title"
                                    type="text"
                                    label={messages['dashboardPanel_name']}
                                    placeholder={messages['dashboardPanel_name']}
                                    value={dashboardName}
                                    onChange={(value) => {
                                        setDashboardName(value)
                                    }}
                                    maxLength={20}
                                    maxLengthMessage={`${messages['accountContacts_maxLengthMessagetitle']} 20`}
                                    required
                                    requiredMessage={messages['required_field']}
                                />
                            </Grid>
                        </Grid>
                    </Form>
                </ModalBody>
                <ModalFooter>
                    <Button
                        onClick={() => {
                            handleClose()
                        }}
                        className="btn-cancel"
                    >
                        {messages["accountContacts_cancel"]}
                    </Button>
                    <Button
                        className="btn-blue"
                        onClick={(e) => {
                            e.preventDefault();
                            setIsWasSent(true);
                            formRef.current.submit();
                        }}
                    >
                        {messages["accountContacts_edit"]}
                    </Button>
                </ModalFooter>
            </Modal>
        </Fragment>
    );
}

export default CreateEditDashboardPanel;
